import React from "react";
import {
  TreeViewContainer,
  VaultItem,
  FolderItem,
  ItemContent,
  Checkbox,
  ExpandIcon,
  ItemLabel,
  LoadingSpinner,
} from "./VaultFolderTreeView.styled";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FolderIcon from "@mui/icons-material/Folder";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import CircularProgress from "@mui/material/CircularProgress";

const VaultFolderTreeView = ({
  vaults,
  vaultFolders,
  expandedVaults,
  selectedDestinations,
  loadingFolders,
  onToggleVault,
  onToggleDestination,
}) => {
  const isVaultSelected = (vaultUuid) => {
    return selectedDestinations.some(
      (d) => d.vaultUuid === vaultUuid && !d.folderUuid
    );
  };

  const isFolderSelected = (vaultUuid, folderUuid) => {
    return selectedDestinations.some(
      (d) => d.vaultUuid === vaultUuid && d.folderUuid === folderUuid
    );
  };

  const handleVaultRootToggle = (vault) => {
    onToggleDestination({
      vaultUuid: vault.id,
      vaultName: vault.title || vault.name,
      folderUuid: null,
      folderName: "Root",
    });
  };

  const handleFolderToggle = (vault, folder) => {
    onToggleDestination({
      vaultUuid: vault.id,
      vaultName: vault.title || vault.name,
      folderUuid: folder.folder_uuid || folder.folderUuid || folder.id,
      folderName: folder.name || folder.title,
    });
  };

  if (vaults.length === 0) {
    return (
      <TreeViewContainer>
        <div
          style={{ padding: "40px", textAlign: "center", color: "#666" }}
        >
          No vaults available
        </div>
      </TreeViewContainer>
    );
  }

  return (
    <TreeViewContainer>
      {vaults.map((vault) => {
        const vaultId = vault.id;
        const vaultName = vault.title || vault.name;
        const isExpanded = expandedVaults.has(vaultId);
        const folders = vaultFolders[vaultId] || [];
        const isLoading = loadingFolders[vaultId];

        return (
          <div key={vaultId}>
            <VaultItem>
              <ExpandIcon onClick={() => onToggleVault(vaultId)}>
                {isExpanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
              </ExpandIcon>

              <Checkbox
                type="checkbox"
                checked={isVaultSelected(vaultId)}
                onChange={() => handleVaultRootToggle(vault)}
              />

              <ItemContent onClick={() => onToggleVault(vaultId)}>
                {isExpanded ? <FolderOpenIcon /> : <FolderIcon />}
                <ItemLabel>{vaultName}</ItemLabel>
              </ItemContent>
            </VaultItem>

            {isExpanded && (
              <div>
                {isLoading ? (
                  <FolderItem style={{ paddingLeft: "60px" }}>
                    <LoadingSpinner>
                      <CircularProgress size={16} />
                      <span>Loading folders...</span>
                    </LoadingSpinner>
                  </FolderItem>
                ) : folders.length === 0 ? (
                  <FolderItem
                    style={{ paddingLeft: "60px", color: "#999" }}
                  >
                    No folders in this vault
                  </FolderItem>
                ) : (
                  folders.map((folder) => {
                    const folderId =
                      folder.folder_uuid ||
                      folder.folderUuid ||
                      folder.id;
                    const folderName = folder.name || folder.title;
                    return (
                      <FolderItem key={folderId}>
                        <Checkbox
                          type="checkbox"
                          checked={isFolderSelected(vaultId, folderId)}
                          onChange={() =>
                            handleFolderToggle(vault, folder)
                          }
                        />

                        <ItemContent>
                          <FolderIcon style={{ fontSize: "18px" }} />
                          <ItemLabel>{folderName}</ItemLabel>
                        </ItemContent>
                      </FolderItem>
                    );
                  })
                )}
              </div>
            )}
          </div>
        );
      })}
    </TreeViewContainer>
  );
};

export default VaultFolderTreeView;

